import React from "react";
import "./SwitchFilter.scss";
import "../Filter.scss";
import { Switch } from 'antd';

const SwitchFilter = ({title, specialKey, temporaryFilterList, setTemporaryFilterList}) => {

  const onChange = (checked) => {
    setTemporaryFilterList({
      ...temporaryFilterList,
      [specialKey]: checked
    })
  };

  return (
    <div className="Filter SwitchFilter">
      <div className="title">
        {title}
      </div>
      <div className="switch">
        <Switch defaultChecked={temporaryFilterList[specialKey]} onChange={onChange} />
      </div>
    </div>
  )
};

export default SwitchFilter;
